import { Injectable } from '@angular/core';
import {
  AuthenticationRequest,
  AuthenticationResponse,
  noAuthentification,
  RefreshTokenResponse,
  User,
} from '@elio/emanager-front/auth/model';
import { AbstractService } from '@elio/emanager-front/shared/data-access/service';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthenticationService extends AbstractService {
  private AUTH_URL = `${this.apiUrl}/auth`;

  login(auth: AuthenticationRequest): Observable<{ user: User; jwtAccessToken: string; rememberMe: boolean }> {
    const request = () =>
      this.http.post<AuthenticationResponse>(`${this.AUTH_URL}/authenticate`, auth, {
        withCredentials: true,
        context: noAuthentification(),
      });

    return this.httpRequest<AuthenticationResponse>({ request }).pipe(
      map((response: AuthenticationResponse) => ({
        user: response.user,
        jwtAccessToken: response.jwtAccessToken,
        rememberMe: auth.rememberMe,
      }))
    );
  }

  refreshToken(): Observable<RefreshTokenResponse> {
    return this.httpRequest({
      request: () =>
        this.http.get<RefreshTokenResponse>(`${this.AUTH_URL}/refreshtoken`, {
          withCredentials: true,
          context: noAuthentification(),
        }),
    });
  }
}
